module.exports = __webpack_public_path__ + "static/img/antro.60df0788.svg";